import { LanguageState } from "@idw-types/state";
import { LanguageActions, LanguageActionTypes } from "../actions/language-actions";
import { RootActions, RootActionTypes } from "../actions/root-actions";

export const initialLanguageState: LanguageState = {
    language: null,
	isLoadingLanguage: false,
	activeLanguage: null,
	content: null,
	initialized: false
};

export const languageReducer = (
	state: LanguageState = initialLanguageState,
	action: LanguageActions | RootActions
) => {
	switch (action.type) {
		case LanguageActionTypes.SET_LANGUAGE:
			return {
				...state,
				language: action.payload.language
			};
        case LanguageActionTypes.SET_LANGUAGE_LOADING:
			return {
				...state,
				isLoadingLanguage: action.payload.isLoading
			};
		case LanguageActionTypes.SET_ACTIVE_LANGUAGE:
			return {
				...state,
				activeLanguage: action.payload.activeLanguage
			};
		case LanguageActionTypes.SET_LANGUAGE_CONTENT:
			return {
				...state,
				content: action.payload.content
			};
		case LanguageActionTypes.SET_LANGUAGE_INITIALIZED:
			return {
				...state,
				initialized: action.payload.initialized
			};
		case RootActionTypes.RESET_STATE:
			return { ...initialLanguageState };
		default:
			return state;
	}
};